import Vue from "vue";
import {
  IMG_PATH,
  ORDER_STATE_LABEL,
  ORDER_SOURCE_TYPE_LABEL,
  QUESTION_TYPE_LABEL,
  NEWS_TYPE_LABEL
} from "@/utils/macro";
import { typeofStr, TYPEOF } from "@/utils/common";
import { formatDate } from "@/utils/date";
const INVALID_DATE = "Invalid Date";
function _tenCheck(val) {
  let _val = val;
  try {
      _val = parseInt(val);
      if (_val == NaN) {
          return 0;
      }
  } catch (error) {
      return 0;
  }
  if (_val <= 9) {
      return "0" + (val || "0");
  }
  return "" + (val || "0");
}

function _genDate(time) {
  try {
      let date = null;
      let timestamp = time;
      let pattern = /^\d+$/;
      if (pattern.test(time)) {
          // 字符串中全是数字
          if (typeofStr(time) == TYPEOF.String && time.length > 0) {
              try {
                  timestamp = parseInt(time);
                  // console.log("TIME >> _genDate >> parseInt timestamp", timestamp);
              } catch (error) {
                  console.warn("TIME >> _genDate >> parseInt catch error", time);
              }
          }
          if (typeofStr(timestamp) != TYPEOF.Number || !timestamp) {
              timestamp = new Date().getTime();
          }
          date = new Date(("" + timestamp).length === 10 ? timestamp * 1000 : timestamp * 1);
      } else {
          // 字符串中含有非数字字符
          date = new Date(time);
      }
      return date;
  } catch (error) {
      return null;
  }
}

/**
 * 格式化SKU商品价格
 * @param {Object} sku SKU商品
 * @param {Number} fixedBit 小数点保留位数
 * @returns
 */
export function formatSkuPrice(sku, fixedBit = 2) {
  if (sku) {
    try {
      // TODO CJL
      // sku.price = "1231.2131";
      // sku.num = 131;
      // console.log("filter.js formatSkuPrice sku", sku, ", fixedBit", fixedBit);
      const { price, num } = sku;
      const _fixedBit = parseInt(fixedBit);
      if (price && num) {
        const _price = parseFloat(price).toFixed(_fixedBit);
        const _num = parseFloat(num).toFixed(_fixedBit);
        const _skuPrice = parseFloat(_price) * parseFloat(_num);
        // console.log("filter.js formatSkuPrice skuPrice", _skuPrice);
        return parseFloat(_skuPrice.toFixed(2));
      }
    } catch (error) {
      console.warn("filter.js formatSkuPrice catch error", error);
    }
  }
  return 0;
}

/**
 * 格式化订单中的所有SKU商品累加后的总价格
 * @param {Array} skuList SKU商品列表
 */
export function formatOrderSkuListTotalPrice(skuList, fixedBit = 2) {
  try {
    if (skuList && typeofStr(skuList) == TYPEOF.Array) {
      return skuList.reduce((pre, cur, index, list) => {
        return (pre += formatSkuPrice(cur, fixedBit));
      }, 0);
    }
  } catch (error) {
    console.warn("filter.js formatOrderSkuListTotalPrice catch error", error);
  }
  return 0;
}

/**
 * 格式化订单状态值为文本
 * @param {Number|String} state 订单状态值
 * @returns
 */
export function formatOrderState(state) {
  try {
    let _state = state;
    if (state != undefined && state != null) {
      if (typeofStr(state) == TYPEOF.Number) {
        _state = "" + state;
      }
      if (typeofStr(_state) == TYPEOF.String) {
        return ORDER_STATE_LABEL[_state] || "未知状态";
      }
    }
  } catch (error) {
    console.warn("filter.js formatOrderState catch error", error);
  }
  return "未知状态";
}

/**
 * 格式化订单来源值为文本
 * @param {Number|String} type 订单来源值
 * @returns
 */
export function formatSourceType(type) {
  try {
    let _type = type;
    if (type != undefined && type != null) {
      if (typeofStr(type) == TYPEOF.Number) {
        _type = "" + type;
      }
      if (typeofStr(_type) == TYPEOF.String) {
        return ORDER_SOURCE_TYPE_LABEL[_type] || "未知来源订单";
      }
    }
  } catch (error) {
    console.warn("filter.js formatSourceType catch error", error);
  }
  return "未知来源订单";
}

/**
 * 格式化问题类型值为文本
 * @param {Number|String} type 问题类型值
 * @returns
 */
export function formatQuestionType(type) {
  try {
    let _type = type;
    if (type != undefined && type != null) {
      if (typeofStr(type) == TYPEOF.Number) {
        _type = "" + type;
      }
      if (typeofStr(_type) == TYPEOF.String) {
        return QUESTION_TYPE_LABEL[_type] || "未知类型";
      }
    }
  } catch (error) {
    console.warn("filter.js formatQuestionType catch error", error);
  }
  return "未知类型";
}

/**
 * 格式化资讯类型值为文本
 * @param {Number|String} type 资讯类型值
 * @returns
 */
export function formatNewsType(type) {
  try {
    let _type = type;
    if (type != undefined && type != null) {
      if (typeofStr(type) == TYPEOF.Number) {
        _type = "" + type;
      }
      if (typeofStr(_type) == TYPEOF.String) {
        return NEWS_TYPE_LABEL[_type] || "未知类型";
      }
    }
  } catch (error) {
    console.warn("filter.js formatNewsType catch error", error);
  }
  return "未知类型";
}

/**
 * 格式化订单收货地址
 * @param {Object} order 订单
 * @returns
 */
export function formatAddress(order, space = "  ") {
  if (order) {
    let str = order.receiverProvince || "";
    if (order.receiverCity) {
      str += space + order.receiverCity;
    }
    if (order.receiverDistrict) {
      str += space + order.receiverDistrict;
    }
    if (order.receiverDetailedAddress) {
      str += space + order.receiverDetailedAddress;
    }
    return str;
  }
  return "";
}

/**
 * 检查并添加图片地址HOST
 * @param {String} imgPath 图片地址|路径
 * @returns
 */
export function imagePathCheck(imgPath) {
  // let path = imgPath;
  console.log("imagePathCheck imagePath", imgPath);
  try {
    if (imgPath) {
      if (imgPath.startsWith("https") || imgPath.startsWith("http")) {
        const clipStr = "https://hd.hdmicrowave.com/img/";
        if (imgPath.startsWith(clipStr)) {
          return IMG_PATH + imgPath.substring(clipStr.length)
        }
        return imgPath;
      } else {
        return IMG_PATH + imgPath;
      }
    }
  } catch (error) {
    console.warn("adjustImagePath catch error", error);
  }
  return imgPath;
}

/**
 * 格式化时间
 * @param {String} time
 * @returns
 */
export function formatCreateTime(time) {
  let date = _genDate(time);
  if (!date) {
      return "非法日期";
  }
  if (date == INVALID_DATE) return "非法日期";
  if (date && date.getTime() == NaN) return "非法日期";
  // console.log("formatCreateTime", time, date);
  return formatDate(date, "yyyy-MM-dd hh:mm:ss");
}

/**
 * 格式化时间
 * @param {String} time
 * @returns
 */
export function formatExportExcelFileTime(time) {
  let date = _genDate(time);
  if (!date) {
      return "非法日期";
  }
  if (date == INVALID_DATE) return "非法日期";
  if (date && date.getTime() == NaN) return "非法日期";
  // console.log("formatExportExcelFileTime", date);
  return formatDate(date, "yyyy-MM-dd-hh-mm-ss");
}

/**
 * 格式化群聊统计时间单位
 * @param {Number} s 秒
 * @returns
 */
export function formatStatSecond(seconds) {
  const s = seconds || 0;
  if (s == 0) {
    return "--";
  }
  if (s < 60) {
    return `${s.toFixed(0).replace(/\.?0*$/, '')}秒`;
  } else if (s < 3600) {
    const minutes = s / 60;
    return `${minutes.toFixed(0).replace(/\.?0*$/, '')}分钟`;
  } else if (s < 86400) {
    const hours = s / 3600;
    return `${hours.toFixed(0).replace(/\.?0*$/, '')}小时`;
  } else if (s < 2592000) {
    const days = s / 86400;
    return `${days.toFixed(0).replace(/\.?0*$/, '')}天`;
  } else if (s < 31536000) {
    const months = s / 2592000;
    return `${months.toFixed(0).replace(/\.?0*$/, '')}月`;
  } else {
    const years = s / 31536000;
    console.log("years" + years);
    return `${years.toFixed(0).replace(/\.?0*$/, '')}年`;
  }
}

export function getFileName(uri) {
  if (uri && ("" + uri).includes("//")) {
    try {
      const url = new URL("" + uri);
      const fileName = url.pathname.substring(
        url.pathname.lastIndexOf("/") + 1
      );
      return fileName;
    } catch (error) {
      console.warn("filter.js getFileName catch error", error);
    }
  }
  return "";
}

/**
 * 注册全局Filter
 */
export function registerFilters() {
  Vue.filter("getFileName", getFileName);
  Vue.filter("formatCreateTime", formatCreateTime);
  Vue.filter("formatSkuPrice", formatSkuPrice);
  Vue.filter("formatOrderState", formatOrderState);
  Vue.filter("formatSourceType", formatSourceType);
  Vue.filter("formatAddress", formatAddress);
  Vue.filter("formatOrderSkuListTotalPrice", formatOrderSkuListTotalPrice);
  Vue.filter("imagePathCheck", imagePathCheck);
  Vue.filter("formatQuestionType", formatQuestionType);
  Vue.filter("formatNewsType", formatNewsType);
  Vue.filter("formatStatSecond", formatStatSecond);
  Vue.filter("formatExportExcelFileTime", formatExportExcelFileTime);
}



// WEBPACK FOOTER //
// ./src/utils/filters.js